import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { Page } from './page.component';
import { HeaderBarActions } from '../../../modules/headerBar';

const mapStateToProps = createStructuredSelector({});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setHeaderTheme: HeaderBarActions.setHeaderTheme,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(Page);
